import {RepeaterDisplayType} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/RepeaterDisplayType';
import {RepeaterDisplayTypeConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/RepeaterDisplayTypeConfig';
import {LimitConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/RepeaterModelConfig';
import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {Units} from '@mintdata/mint-kit/api/models/Units';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {AIntegerConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AIntegerConfig';
import {getArrayConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ArrayConfig';
import {SimpleUnitsConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/UnitsConfig';
import * as React from 'react';

export const DEFAULT_TILES_NUMBER_OF_COUNT:number = 2;

export class RepeaterModel
{
    @Property<AInteger>({
        title: '',
        tip: '',
        isRequired: true,
        typeConfig: AIntegerConfig,
        typeCtor: AInteger,
        isManualConfirmation: true,
        keepValueAfterBindingRemoving: false
    })
    public count:AInteger = null;

    @Property<RepeaterDisplayType>({
        title: '',
        tip: '',
        isRequired: false,
        typeConfig: RepeaterDisplayTypeConfig,
        typeCtor: RepeaterDisplayType
    })
    public displayType:RepeaterDisplayType = null;

    @Property<Units>({
        title: '',
        tip: '',
        isRequired: false,
        typeConfig: SimpleUnitsConfig,
        typeCtor: Units,
        isManualConfirmation: true
    })
    public offsetX:Units = null;

    @Property<Units>({
        title: '',
        tip: '',
        isRequired: false,
        typeConfig: SimpleUnitsConfig,
        typeCtor: Units,
        isManualConfirmation: true
    })
    public offsetY:Units = null;

    @Property<AInteger>({
        title: '',
        tip: '',
        isRequired: false,
        typeConfig: AIntegerConfig,
        typeCtor: AInteger,
        isManualConfirmation: true
    })
    public numberOfColumns:AInteger = null;

    @Property<AInteger>({
        title: '',
        tip: '',
        isRequired: true,
        typeConfig: AIntegerConfig,
        typeCtor: AInteger,
        isManualConfirmation: true
    })
    public offset:AInteger = null;

    @Property<AInteger>({
        title: '',
        tip: '',
        isRequired: false,
        typeConfig: LimitConfig,
        typeCtor: AInteger,
        isManualConfirmation: true
    })
    public limit:AInteger = null;

    public constructor(count:ANumber = null,
                       displayType:RepeaterDisplayType = RepeaterDisplayType.vertical(),
                       offsetX:Units = null,
                       offsetY:Units = null,
                       numberOfColumns:AInteger = AInteger.fromNumber(DEFAULT_TILES_NUMBER_OF_COUNT),
                       offset:AInteger = AInteger.fromNumber(1),
                       limit:AInteger = null)
    {
        this.count = count;
        this.displayType = displayType;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        this.numberOfColumns = numberOfColumns;
        this.offset = offset;
        this.limit = limit;
    }

    @Property<AInteger>({
        title: '',
        tip: '',
        isRequired: false,
        typeConfig: getArrayConfig(AIntegerConfig),
        typeCtor: AInteger,
        keepValueAfterBindingRemoving: false
    })
    public get values():Array<AInteger>
    {
        return this.count && this.count.value != null && this.count.value >= 0 ? new Array(this.count.value) : null;
    }

    public set values(values:Array<AInteger>)
    {
        this.count = values ? AInteger.fromNumber(values.length) : null;
    }
}
